import Vue from 'vue'
import App from './App.vue'
import router from './router'
import commonMixin from '@/common/mixin.js';
import store from './store'
import storejs from 'store'
import './registerServiceWorker'
import './services/xhr'
import './services/libs/rem.js'

import appService from "@/services/request/appService"

import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';

import Vant from 'vant';
import 'vant/lib/index.css'

import Calendar from 'vue-mobile-calendar'

Vue.use(Calendar)

Vue.use(Vant);
// mixin
Vue.mixin(commonMixin);

//图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
	preLoad: 1,
	loading: require('./assets/images/img_loading.png'),
	attempt: 1
})


const u = navigator.userAgent;
let page = {
  isInApp: u.indexOf('Finger') !== -1 || u.indexOf('finger') !== -1, // 是否在app中
  isInWechat: u.indexOf('MicroMessenger') !== -1 && u.indexOf('wxwork') === -1, // 在普通微信中
  isInMiniprogram: window.__wxjs_environment === "miniprogram", // 是否在小程序中
  isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // 是否是安卓
  isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否是ios
}

Vue.prototype.$page = page

import $ from 'jquery'
window.$ = $
window.jQuery = $


Vue.use(YDUI);
Vue.config.productionTip = false

Vue.prototype.htmlDecode = function (value) {
	var div = document.createElement("div");
	div.innerHTML = value;
	//epsilon 之前版本有以下处理，不解！
	// var txt = div.innerText || div.textContent;
	var txt = div.innerHTML
	div = null;
	return txt;
}

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  
  if(storejs.get('groupClubTs') && to.name != 'ActivityDetail'){
    console.log('to',to)
    let ts = new Date().getTime()
    if(ts - storejs.get('groupClubTs') > (1000 * 60 * 24 * 3)){//3天
      console.log('推出登录',ts - storejs.get('groupClubTs'))
      location.href = `/login?iid=${storejs.get('loginData').iid}`
      localStorage.clear()
    }else{
      next()
    }
  }else{
    next()
  }

  
})

router.afterEach((to, form) => {

  //路由变换后自动滚到顶部
  window.scroll(0, 0);
  document.body.scrollIntoView(true);
})

if (window.location.pathname.substring(0, 3) === '/s/') {

  let url = window.location.pathname.replace('/s/', '');
  (async () => {
    let res = await appService.parseShortUrl({url});
    window.location.href = res;
  })();
}else{
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
